import { BsXLg } from "react-icons/bs";
import { GoZap } from "react-icons/go";
import { LuWrench, LuCircleArrowUp } from "react-icons/lu";
import css from "./ChangeLogModal.module.css";
import { formatDate } from "../../../utils/renderTime.jsx";
import {
  selectCurrentVersionChanges,
  selectIsChangeLogLoading,
} from "../../../redux/changeLog/selectors.js";
import { useDispatch, useSelector } from "react-redux";
import LoaderSvg from "../../Loader/LoaderSvg.jsx";
import { useEffect } from "react";
import { markCurrentVersionChangesAsRead } from "../../../redux/changeLog/operations.js";
import { markAsRead } from "../../../redux/changeLog/slice.js";

const entryTypeConfig = {
  feature: {
    label: "Новий функціонал",
    icon: GoZap,
    className: css.typeFeature,
  },
  improvement: {
    label: "Покращення",
    icon: LuCircleArrowUp,
    className: css.typeImprovement,
  },
  fix: {
    label: "Виправлення",
    icon: LuWrench,
    className: css.typeFix,
  },
};

export default function ChangeLogModal({ onClose }) {
  const dispatch = useDispatch();
  const currentVersionChanges = useSelector(selectCurrentVersionChanges);
  const isChangeLogLoading = useSelector(selectIsChangeLogLoading);

  useEffect(() => {
    if (currentVersionChanges.is_read === true) return;
    dispatch(markAsRead());
    dispatch(markCurrentVersionChangesAsRead(currentVersionChanges.id));
  }, []);

  return (
    <div className={css.container}>
      <div className={css.header}>
        <div className={css.headerLeft}>
          <h2 className={css.title}>Що нового?</h2>
        </div>
        <button className={css.closeBtn} onClick={onClose} type="button">
          <BsXLg />
        </button>
      </div>

      <div className={css.body}>
        {isChangeLogLoading ? (
          <LoaderSvg />
        ) : Object.entries(currentVersionChanges) === 0 ? (
          <p className={css.empty}>Немає оновлень</p>
        ) : (
          <div key={currentVersionChanges.id} className={css.release}>
            <div className={css.releaseHeader}>
              <div className={css.versionBadge}>
                v{currentVersionChanges.version}
              </div>
              <span className={css.releaseTitle}>
                {currentVersionChanges.title}
              </span>
              <span className={css.releaseDate}>
                {formatDate(currentVersionChanges.published_at)}
              </span>
            </div>

            {currentVersionChanges.body && (
              <div
                className={css.releaseBody}
                dangerouslySetInnerHTML={{ __html: currentVersionChanges.body }}
              />
            )}

            {currentVersionChanges.entries?.length > 0 && (
              <ul className={css.entriesList}>
                {currentVersionChanges.entries.map(entry => {
                  const config =
                    entryTypeConfig[entry.type] ?? entryTypeConfig.feature;
                  const Icon = config.icon;
                  return (
                    <li
                      key={entry.id}
                      className={`${css.entry} ${config.className}`}
                    >
                      <Icon className={css.entryIcon} />
                      <span className={css.entryTitle}>{entry.title}</span>
                      <span className={css.entryText}>{entry.body}</span>
                      <span className={css.entryTypeBadge}>{config.label}</span>
                    </li>
                  );
                })}
              </ul>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
